import { valibotResolver } from '@hookform/resolvers/valibot';
import { nonEmpty, object, pipe, number, custom } from 'valibot';

export const MOVE_LOCATION_FIELDS = {
  NEW_PARENT_ID: 'newParentId',
};

const checkNewLocation = (newLocation, currentLocation) => {
  return newLocation !== currentLocation;
}

export const schemaMoveLocation = (currentParentId) => valibotResolver(
  object({
    [MOVE_LOCATION_FIELDS.NEW_PARENT_ID]: pipe(
      number(),
      nonEmpty('This field is required.'),
      custom((newParentId) => checkNewLocation(newParentId, currentParentId), 'The parent location has not been changed.'))
  }),
);

export const moveLocationDefaultValue = (parentId) => ({
  [MOVE_LOCATION_FIELDS.NEW_PARENT_ID]: parentId,
});